import { render, staticRenderFns } from "./inspection-index.vue?vue&type=template&id=519fe168"
import script from "./inspection-index.vue?vue&type=script&lang=js"
export * from "./inspection-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports